// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** Dominican Republic */
const DO: PhoneNumberData = [1, 'DO', 10, format0, /^(?:8001|8[024]9)/];

export default DO;
